import {Alert, Typography} from '@mui/material';
import {BlockRounded} from '@mui/icons-material';
import moment from 'moment';
import {useTranslation} from 'react-i18next';
import {AttendanceTrackerSessionVoided} from '../../backend/responses/attendance-tracker-session';
import {translations} from '../../i18n/translations';

type AttendanceVoidedNoticeProps = {
  voided?: AttendanceTrackerSessionVoided;
};

/** Says, in the details of a session, that it was voided: it does not count anymore. Who voided it, when and why. */
export const AttendanceVoidedNotice = ({voided}: AttendanceVoidedNoticeProps) => {
  const {t} = useTranslation();
  const texts = translations.daily_care_log.attendance_tracker;

  if (!voided) {
    return null;
  }

  return (
    <Alert severity="info" icon={<BlockRounded />}>
      <Typography sx={{fontSize: '14px', fontWeight: 500}}>
        {t(texts.voided.notice, {
          name: voided.by?.name || t(texts.manual.unknown_user),
          date: moment(voided.at).format('DD/MM/YYYY HH:mm'),
        })}
      </Typography>
      {voided.reason && (
        <Typography sx={{fontSize: '14px', overflowWrap: 'anywhere'}}>
          {t(texts.voided.reason, {reason: voided.reason})}
        </Typography>
      )}
    </Alert>
  );
};
